module.exports = __webpack_public_path__ + "static/img/all-items.2342429.png";